

import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, takeUntil, withLatestFrom } from 'rxjs';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { Select, ofActionSuccessful } from '@ngxs/store';

import { NgxsActionName, NgxsFormPath, SelectItems } from '@app/shared/constants';
import { AngularMaterialModule } from '@app/shared/modules/angular-material.module';
import * as AppDataAction from '@app/shared/actions/app-data.action';
import { AppDataState } from '@app/shared/stores/app-data.state';
import { SpinnerButtonComponent } from '@shared/components/spinner-button/spinner-button.component';
import { InjectDialogData } from '@shared/components/edit-modal-dialog/edit-modal-dialog.constant';
import { WebApiResponseBase } from '@app/shared/classes/general';
import { EditModalDialogBasedComponent } from '@shared/components/edit-modal-dialog/edit-modal-dialog.based.component';
import { KpiSafety } from '@app/shared/classes/kpi-safety';
import { Status } from '@app/shared/enums';
import { SafetyFieldName } from '@app/pages/kpi-data-mgmt/safety/safety.constant';

@Component({
  selector: 'app-safety-edit-modal-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, SpinnerButtonComponent, TranslateModule, NgxsFormPluginModule, ReactiveFormsModule, MatDialogModule, AngularMaterialModule],
  templateUrl: './safety-edit-modal-dialog.component.html',
  styleUrl: './safety-edit-modal-dialog.component.css'
})
export class SafetyEditModalDialogComponent extends EditModalDialogBasedComponent<SafetyEditModalDialogComponent, KpiSafety> {
  statusSelectItems = SelectItems.statusSelectItems;
  formPath = NgxsFormPath.KPI_SAFETY_EDIT_FORM;
  status = Status;

  @Select(AppDataState.taskExecuting(NgxsActionName.UPDATE_KPI_SAFETY)) updating$: Observable<boolean>;
  @Select(AppDataState.taskError(NgxsActionName.UPDATE_KPI_SAFETY)) response$: Observable<WebApiResponseBase>;

  constructor(public dialogRef: MatDialogRef<SafetyEditModalDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: InjectDialogData<KpiSafety>) {
    super();
    this.dataInit(dialogRef, data);
    this.initForm(data);
  }

  initForm = (data: InjectDialogData<KpiSafety>) => {
    this.editForm = this.formBuilder.group({
      status: data.data.status,
      kpiSaftyComment: data.data.kpiSaftyComment
    });

    this.updateCommentValidation(data.data.status as Status);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.actions$.pipe(ofActionSuccessful(AppDataAction.UpdateKpiSafety), withLatestFrom(this.response$), takeUntil(this.destroy$)).subscribe(
      ([_, errorResponse]) => this.processAfterUpdateObject(errorResponse));
  }

  onStatusSelectionChanged = (event: any) => {
    this.updateCommentValidation(event.value);
  }

  updateCommentValidation = (status: Status) => {
    var commentField = this.editForm.get(SafetyFieldName.kpiSaftyComment);
    commentField.clearValidators();

    if (status === Status.INACTIVE) {
      commentField.addValidators(Validators.required);
    }

    commentField.updateValueAndValidity();
  }

  onOkClick = () => {
    this.store.dispatch(new AppDataAction.UpdateKpiSafety(this.data.data));
  }
}
